// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lRVwbuCE3HEr9SvAHNZT {
  position: sticky !important;
  top: 0;
  z-index: 20;
  height: var(--header-height);
}
`, "",{"version":3,"sources":["webpack://./src/components/header/header-menu/HeaderMenu.module.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,MAAM;EACN,WAAW;EACX,4BAA4B;AAC9B","sourcesContent":[".headerMenu {\n  position: sticky !important;\n  top: 0;\n  z-index: 20;\n  height: var(--header-height);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerMenu": `lRVwbuCE3HEr9SvAHNZT`
};
export default ___CSS_LOADER_EXPORT___;
